import { createFileRoute } from "@tanstack/react-router";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibrarySharedProgramsListPage } from "src/pages/CoachLibrarySharedProgramsListPage";

export const Route = createFileRoute(
  "/_auth/_coach/library/programs/$programId/shared/",
)({
  component: RoutePage,
  ssr: true,
  async loader({ params }) {
    return await loaderHandler(async ({ trpc }) => {
      assert(params.programId, "No programId");

      const shareables = await trpc.listShareables.query({
        pageIndex: 0,
        programId: params.programId,
      });

      return {
        data: {
          shareables,
        },
      };
    });
  },
});

function RoutePage() {
  return <CoachLibrarySharedProgramsListPage />;
}
